import * as React from 'react';
import { getBaseUrl } from '@/redux/modules/config';
import { useAppSelector } from '@/redux/hooks';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import PageHeaderMeta from '@liveauctioneers/caterwaul-components/lib/PageHeaderMeta/PageHeaderMeta';
import useAddNotificationCountToTitle from '@/hooks/useAddNotificationCountToTitle';

const FeaturesPageHeaderMeta = () => {
    const { formatMessage } = useIntl();
    const baseUrl = useAppSelector(getBaseUrl);
    const title = useAddNotificationCountToTitle(formatMessage({ id: 'features_and_services' }));
    const description = formatMessage({
        id: 'exceptional_items_from_trusted_auction_houses',
    });
    const canonical = `${baseUrl}/features`;

    return (
        <PageHeaderMeta
            canonical={canonical}
            description={description}
            title={title}
        />
    );
};

export default FeaturesPageHeaderMeta;
